<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
@import "~@/Styles/color.less";

*{
  padding: 0;
  border: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  font-size: 16px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue